import { render, staticRenderFns } from "./CrisisMonitorCard.vue?vue&type=template&id=2832f01d&scoped=true"
import script from "./CrisisMonitorCard.vue?vue&type=script&lang=ts"
export * from "./CrisisMonitorCard.vue?vue&type=script&lang=ts"
import style0 from "./CrisisMonitorCard.vue?vue&type=style&index=0&id=2832f01d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832f01d",
  null
  
)

export default component.exports